import { FC } from 'react';
import Image from 'next/image';
import { Skeleton } from 'antd';
import HeartButtonSkeleton from '@components/skeleton/heartButton/HeartButton';
import ShareButtonSkeleton from '@components/skeleton/shareButton/ShareButton';
import SkeletonTag from '@components/skeleton/tag/Tag';
import { useScreen } from '@shared/helpers/screen.helper';
import { ButtonWrapper, CollapseSkeleton, CollapseWrapper, Container, DescriptionSkeleton, DetailWrapper, NavigationSkeleton, PackshotOptionSkeleton, PackshotSkeleton, PackshotWrapper, TagWrapper, TitleSkeleton, TitleWrapper, Wrapper, WrapperProduct } from './ProductDetail.style';
const ProductDetailSkeleton: FC = () => {
  const {
    isMobile
  } = useScreen();
  const renderCollapseSkeleton = () => {
    return <CollapseSkeleton>
                <TitleWrapper>
                    <Skeleton.Input size="large" className="title" active />
                    <Image src="/icons/arrow-collapse.svg" alt="arrow collapse" width={16} height={8} />
                </TitleWrapper>
                <Skeleton title={false} paragraph={{
        rows: 3
      }} active />
            </CollapseSkeleton>;
  };
  const renderMobile = () => {
    return <Container>
                <Wrapper>
                    <PackshotSkeleton active />
                    <DetailWrapper>
                        <TitleSkeleton active />
                        <DescriptionSkeleton size="default" active />
                        <TagWrapper>
                            <SkeletonTag />
                            <SkeletonTag />
                        </TagWrapper>
                    </DetailWrapper>
                </Wrapper>
            </Container>;
  };
  return isMobile ? renderMobile() : <Container>
            <Wrapper>
                <WrapperProduct>
                    <PackshotWrapper>
                        <PackshotSkeleton active />
                        <PackshotOptionSkeleton active />
                    </PackshotWrapper>
                    <DetailWrapper>
                        <NavigationSkeleton />
                        <TitleSkeleton active />
                        <DescriptionSkeleton size="default" active />
                        <TagWrapper>
                            <SkeletonTag />
                            <SkeletonTag />
                        </TagWrapper>
                        <ButtonWrapper>
                            <HeartButtonSkeleton />
                            <ShareButtonSkeleton />
                        </ButtonWrapper>
                        <CollapseWrapper>
                            {renderCollapseSkeleton()}
                            {renderCollapseSkeleton()}
                            {renderCollapseSkeleton()}
                        </CollapseWrapper>
                    </DetailWrapper>
                </WrapperProduct>
            </Wrapper>
        </Container>;
};
export default ProductDetailSkeleton;